/**
 * Tipos de acciones para historial de tickets
 */

// Obtener historial
export const GET_HISTORY_REQUEST = 'GET_HISTORY_REQUEST';
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS';
export const GET_HISTORY_FAILURE = 'GET_HISTORY_FAILURE';

// Invalidar el historial de un ticket específico
export const INVALIDATE_TICKET_HISTORY = 'INVALIDATE_TICKET_HISTORY'; 